export default __webpack_public_path__ + "static/app-store-badge-f34e37530055b2c97ba3828e574e85f3.svg";